export const arraysValuesCompare = (arr1: any[], arr2: any[]) => {
  if (arr1.length !== arr2.length) return false;
  const arr1Copy = [...arr1].sort();
  const arr2Copy = [...arr2].sort();
  return arr1Copy.every((v, i) => v === arr2Copy[i]);
}